<template>
    <div class="settings-page">
        <!-- Mensajes de estado -->
        <div v-if="error" class="alert alert-error">
            {{ error }}
        </div>
        <div v-if="success" class="alert alert-success">
            {{ success }}
        </div>
        
        <div class="settings-grid">
            <!-- Profile Settings -->
            <div class="settings-card">
                <div class="card-header">
                    <h3><i class="fa-solid fa-user"></i> Perfil de Usuario</h3>
                </div>
                <div class="card-content">
                    <form @submit.prevent="saveProfile">
                        <div class="form-group">
                            <label>Nombre de Usuario</label>
                            <input type="text" v-model="profile.username" required>
                        </div>
                        <div class="form-group">
                            <label>Email</label>
                            <input type="email" v-model="profile.email" required>
                        </div>
                        <div class="form-group">
                            <label>Nombre Completo</label>
                            <input type="text" v-model="profile.fullName" required>
                        </div>
                        <button type="submit" class="save-btn">Guardar Cambios</button>
                    </form>
                </div>
            </div>

            <!-- Security Settings -->
            <div class="settings-card">
                <div class="card-header">
                    <h3><i class="fa-solid fa-shield-alt"></i> Seguridad</h3>
                </div>
                <div class="card-content">
                    <form @submit.prevent="changePassword">
                        <div class="form-group">
                            <label>Contraseña Actual</label>
                            <input type="password" v-model="security.currentPassword" required>
                        </div>
                        <div class="form-group">
                            <label>Nueva Contraseña</label>
                            <input type="password" v-model="security.newPassword" required>
                        </div>
                        <div class="form-group">
                            <label>Confirmar Nueva Contraseña</label>
                            <input type="password" v-model="security.confirmPassword" required>
                        </div>
                        <button type="submit" class="save-btn">Cambiar Contraseña</button>
                    </form>
                </div>
            </div>

            <!-- Appearance Settings -->
            <div class="settings-card">
                <div class="card-header">
                    <h3><i class="fa-solid fa-palette"></i> Apariencia</h3>
                </div>
                <div class="card-content">
                    <div class="form-group">
                        <label>Modo Oscuro</label>
                        <div class="toggle-switch">
                            <input type="checkbox" id="darkMode" v-model="appearance.darkMode" @change="toggleDarkMode">
                            <label for="darkMode"></label>
                        </div>
                    </div>
                    <div class="form-group">
                        <label>Idioma</label>
                        <select v-model="appearance.language">
                            <option value="es">Español</option>
                            <option value="en">English</option>
                        </select>
                    </div>
                    <div class="form-group">
                        <label>Notificaciones</label>
                        <div class="checkbox-group">
                            <label class="checkbox-item">
                                <input type="checkbox" v-model="appearance.emailNotifications">
                                <span class="checkmark"></span>
                                Notificaciones por email
                            </label>
                            <label class="checkbox-item">
                                <input type="checkbox" v-model="appearance.pushNotifications">
                                <span class="checkmark"></span>
                                Notificaciones push
                            </label>
                        </div>
                    </div>
                </div>
            </div>

            <!-- System Info -->
            <div class="settings-card">
                <div class="card-header">
                    <h3><i class="fa-solid fa-info-circle"></i> Información del Sistema</h3>
                </div>
                <div class="card-content">
                    <div class="info-item">
                        <span class="label">Versión:</span>
                        <span class="value">1.0.0</span>
                    </div>
                    <div class="info-item">
                        <span class="label">Última actualización:</span>
                        <span class="value">{{ systemInfo.lastUpdate }}</span>
                    </div>
                    <div class="info-item">
                        <span class="label">Proyectos en portafolio:</span>
                        <span class="value">{{ systemInfo.totalProjects }}</span>
                    </div>
                    <div class="info-item">
                        <span class="label">Espacio utilizado:</span>
                        <span class="value">{{ systemInfo.usedSpace }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import apiService from '../config/api.js';

export default {
    name: 'SettingsPage',
    data() {
        return {
            profile: {
                username: '',
                email: '',
                fullName: ''
            },
            security: {
                currentPassword: '',
                newPassword: '',
                confirmPassword: ''
            },
            appearance: {
                darkMode: false,
                language: 'es',
                emailNotifications: true,
                pushNotifications: false
            },
            systemInfo: {
                lastUpdate: '',
                totalProjects: 0,
                usedSpace: '0 MB'
            },
            loading: false,
            error: null,
            success: null
        }
    },
    async mounted() {
        this.appearance.darkMode = document.body.classList.contains('dark-theme');
        await this.loadUserData();
        await this.loadSystemInfo();
    },
    methods: {
        async loadUserData() {
            try {
                console.log('👤 Cargando datos del usuario...');
                const user = JSON.parse(localStorage.getItem('user') || '{}');
                
                this.profile = {
                    username: user.username || '',
                    email: user.email || '',
                    fullName: user.full_name || ''
                };
                
                console.log('✅ Datos del usuario cargados:', this.profile);
            } catch (error) {
                console.error('❌ Error cargando datos del usuario:', error);
                this.error = 'Error al cargar los datos del usuario';
            }
        },
        
        async loadSystemInfo() {
            try {
                console.log('📊 Cargando información del sistema...');
                
                // Obtener estadísticas de proyectos
                const statsResponse = await apiService.getProjectStats();
                console.log('📈 Respuesta de estadísticas:', statsResponse);
                
                if (statsResponse && statsResponse.success) {
                    this.systemInfo.totalProjects = statsResponse.data.total_projects || 0;
                    this.systemInfo.lastUpdate = new Date().toLocaleDateString('es-ES');
                    this.systemInfo.usedSpace = '2.5 MB'; // Esto se podría calcular realmente
                }
                
                console.log('✅ Información del sistema cargada');
            } catch (error) {
                console.error('❌ Error cargando información del sistema:', error);
            }
        },
        
        async saveProfile() {
            this.loading = true;
            this.error = null;
            this.success = null;
            
            try {
                console.log('💾 Guardando perfil:', this.profile);
                
                // Aquí se actualizaría el perfil en la base de datos
                // Por ahora solo actualizamos localStorage
                const user = JSON.parse(localStorage.getItem('user') || '{}');
                const updatedUser = {
                    ...user,
                    username: this.profile.username,
                    email: this.profile.email,
                    full_name: this.profile.fullName
                };
                
                localStorage.setItem('user', JSON.stringify(updatedUser));
                
                this.success = 'Perfil actualizado correctamente';
                console.log('✅ Perfil guardado exitosamente');
                
                // Limpiar mensaje después de 3 segundos
                setTimeout(() => {
                    this.success = null;
                }, 3000);
                
            } catch (error) {
                console.error('❌ Error guardando perfil:', error);
                this.error = 'Error al guardar el perfil';
            } finally {
                this.loading = false;
            }
        },
        
        async changePassword() {
            if (this.security.newPassword !== this.security.confirmPassword) {
                this.error = 'Las contraseñas no coinciden';
                return;
            }
            
            if (this.security.newPassword.length < 6) {
                this.error = 'La nueva contraseña debe tener al menos 6 caracteres';
                return;
            }
            
            this.loading = true;
            this.error = null;
            this.success = null;
            
            try {
                console.log('🔐 Cambiando contraseña...');
                
                const response = await apiService.changePassword(
                    this.security.currentPassword,
                    this.security.newPassword
                );
                
                console.log('📡 Respuesta del cambio de contraseña:', response);
                
                if (response && response.success) {
                    this.success = 'Contraseña cambiada correctamente';
                    this.security = {
                        currentPassword: '',
                        newPassword: '',
                        confirmPassword: ''
                    };
                    console.log('✅ Contraseña cambiada exitosamente');
                } else {
                    const errorMsg = response?.error || 'Error al cambiar la contraseña';
                    console.error('❌ Error en cambio de contraseña:', errorMsg);
                    this.error = errorMsg;
                }
                
                // Limpiar mensajes después de 3 segundos
                setTimeout(() => {
                    this.success = null;
                    this.error = null;
                }, 3000);
                
            } catch (error) {
                console.error('❌ Error cambiando contraseña:', error);
                this.error = 'Error al cambiar la contraseña';
            } finally {
                this.loading = false;
            }
        },
        
        toggleDarkMode() {
            document.body.classList.toggle('dark-theme', this.appearance.darkMode);
        }
    }
}
</script>

<style lang="scss" scoped>
.settings-page {
    .alert {
        padding: 12px 20px;
        border-radius: 8px;
        margin-bottom: 20px;
        font-weight: 500;
        
        &.alert-error {
            background: #fee;
            color: #c33;
            border: 1px solid #fcc;
        }
        
        &.alert-success {
            background: #efe;
            color: #3c3;
            border: 1px solid #cfc;
        }
    }
    
    .settings-grid {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
        gap: 30px;

        .settings-card {
            background: white;
            border-radius: 12px;
            box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
            overflow: hidden;

            .card-header {
                background: #f8f9fa;
                padding: 20px 30px;
                border-bottom: 1px solid #e1e5e9;

                h3 {
                    margin: 0;
                    font-size: 18px;
                    font-weight: 600;
                    color: #333;
                    display: flex;
                    align-items: center;
                    gap: 10px;

                    i {
                        color: #1f8cc6;
                    }
                }
            }

            .card-content {
                padding: 30px;

                .form-group {
                    margin-bottom: 20px;

                    label {
                        display: block;
                        margin-bottom: 8px;
                        font-weight: 500;
                        color: #333;
                    }

                    input, select {
                        width: 100%;
                        padding: 12px;
                        border: 2px solid #e1e5e9;
                        border-radius: 8px;
                        font-size: 14px;

                        &:focus {
                            outline: none;
                            border-color: #1f8cc6;
                        }
                    }

                    .toggle-switch {
                        position: relative;
                        width: 60px;
                        height: 30px;

                        input {
                            opacity: 0;
                            width: 0;
                            height: 0;

                            &:checked + label {
                                background: #1f8cc6;

                                &:before {
                                    transform: translateX(30px);
                                }
                            }
                        }

                        label {
                            position: absolute;
                            cursor: pointer;
                            top: 0;
                            left: 0;
                            right: 0;
                            bottom: 0;
                            background: #ccc;
                            border-radius: 30px;
                            transition: 0.3s;

                            &:before {
                                position: absolute;
                                content: "";
                                height: 26px;
                                width: 26px;
                                left: 2px;
                                bottom: 2px;
                                background: white;
                                border-radius: 50%;
                                transition: 0.3s;
                            }
                        }
                    }

                    .checkbox-group {
                        .checkbox-item {
                            display: flex;
                            align-items: center;
                            margin-bottom: 10px;
                            cursor: pointer;
                            font-size: 14px;

                            input[type="checkbox"] {
                                display: none;
                            }

                            .checkmark {
                                width: 18px;
                                height: 18px;
                                border: 2px solid #e1e5e9;
                                border-radius: 4px;
                                margin-right: 10px;
                                position: relative;
                                transition: all 0.3s ease;

                                &::after {
                                    content: '';
                                    position: absolute;
                                    left: 5px;
                                    top: 2px;
                                    width: 6px;
                                    height: 10px;
                                    border: solid white;
                                    border-width: 0 2px 2px 0;
                                    transform: rotate(45deg);
                                    opacity: 0;
                                    transition: opacity 0.3s ease;
                                }
                            }

                            input[type="checkbox"]:checked + .checkmark {
                                background: #1f8cc6;
                                border-color: #1f8cc6;

                                &::after {
                                    opacity: 1;
                                }
                            }
                        }
                    }
                }

                .save-btn {
                    background: #1f8cc6;
                    color: white;
                    border: none;
                    padding: 12px 24px;
                    border-radius: 8px;
                    cursor: pointer;
                    font-weight: 500;
                    transition: all 0.3s ease;

                    &:hover {
                        background: #167aad;
                    }
                }

                .info-item {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    padding: 15px 0;
                    border-bottom: 1px solid #f0f0f0;

                    &:last-child {
                        border-bottom: none;
                    }

                    .label {
                        font-weight: 500;
                        color: #666;
                    }

                    .value {
                        color: #333;
                        font-weight: 600;
                    }
                }
            }
        }
    }
}

// Dark theme
body.dark-theme .settings-page {
    .alert {
        &.alert-error {
            background: #3a1a1a;
            color: #ff6b6b;
            border-color: #4a2a2a;
        }
        
        &.alert-success {
            background: #1a3a1a;
            color: #6bff6b;
            border-color: #2a4a2a;
        }
    }
    
    .settings-card {
        background: #2b2a2a;

        .card-header {
            background: #1f2122;
            border-bottom-color: #444;

            h3 {
                color: #ffffff;
            }
        }

        .card-content {
            .form-group {
                label {
                    color: #ffffff;
                }

                input, select {
                    background: #1f2122;
                    border-color: #444;
                    color: #ffffff;

                    &:focus {
                        border-color: #f08908;
                    }
                }

                .checkbox-item {
                    color: #ccc;

                    .checkmark {
                        border-color: #444;
                    }
                }
            }

            .info-item {
                border-bottom-color: #444;

                .label {
                    color: #ccc;
                }

                .value {
                    color: #ffffff;
                }
            }
        }
    }
}

// Responsive
@media (max-width: 768px) {
    .settings-page {
        .settings-grid {
            grid-template-columns: 1fr;
            gap: 20px;

            .settings-card {
                .card-content {
                    padding: 20px;
                }
            }
        }
    }
}
</style> 